import { Card, TinyTable } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $overviewRecentBills } from '../../_state/financeOverview.state';

import { useRecentBillsColumns } from './hooks/useRecentBillsColumns';

import { useTranslations } from '@/finance/i18n/useTranslations';

export const OverviewRecentBills = () => {
  const t = useTranslations();
  const { data, isFetching } = useAtomValue($overviewRecentBills);
  const { columns } = useRecentBillsColumns();

  const bills = data?.bills ?? [];

  return (
    <Card className="@OverviewRecentBills flex h-full flex-col">
      <h3 className="text-lg font-semibold">{t.overview.recentBills.title}</h3>
      <p className="text-sm text-neutral">{t.overview.recentBills.subtitle}</p>
      {!isFetching && bills.length === 0 ? (
        <p className="py-8 text-center text-sm text-neutral">
          {t.overview.recentBills.empty}
        </p>
      ) : (
        <TinyTable
          data={bills}
          isLoading={isFetching}
          rowKey={(row) => row.id}
          columns={columns}
          className="overflow-y-auto"
          headerClassName="bg-neutral/8 font-semibold text-neutral [&_*]:opacity-100"
          rowClassName="bg-white"
        />
      )}
    </Card>
  );
};
